//import { ApObject } from './ap-object.model';
import { GeoDsDocument } from './document.model';
import { GeoDsMeta } from './meta-data.model';

export class Address extends GeoDsMeta {
  Name: string;
  Name2: string;
  CustomerNumber: number;
  ContactSource: string;
  Street: string;
  City: string;
  HouseNumber: string;
  Country: string;
  ZIP: string;
  Status: string;
  Phone2: string;
  Fax: string;
  CompanyTitle: string;
  RegisterofCompanies: string;
  MatchCode: string;
  Documents: GeoDsDocument[];
  Locked: boolean;
  Category: string;
  Comment: string;
  EMail: string;
  LegalForm: string;
  IdRefPersonChecked: string;
  Website: string;
  Phone: string;
  PhoneNumbers: IPhoneNumber[];
  MailAddresses: MailAddress[];
  RegisterCourt: string;
  Reserve3: string;
  constructor(data?: Address) {
    super();
    Object.assign(this, data);
  }
}

export class IPhoneNumber {
  Number: string;
  Type?: string;
  Kind?: string;
  Id: string;
  CountryCode?: string;
  NationalNumber?: string;
  DialCode?: string;
  Designation?: string;
  InternationalNumber?: string;
}

export class MailAddress {
  Id: string;
  MainAdress: boolean;
  Type: boolean;
  Value: string;
}
